/**
 * Responsive layout breakpoints for the employer-app navigation. Ported from
 * cnect-ux's `src/app/shared/nav-breakpoints.ts` to keep the IA reference and
 * the production app in sync.
 *
 * Story 2.1.
 */

export const NAV_BREAKPOINTS = Object.freeze({
  mobileMax: 767,
  tabletMin: 768,
  tabletMax: 1023,
  smallDesktopMin: 1024,
  smallDesktopMax: 1279,
  desktopMin: 1280,
  desktopMax: 1439,
  xlMin: 1440,
})

export type NavTier = 'mobile' | 'tablet' | 'small-desktop' | 'desktop' | 'xl'

export function navTierFromWidth(widthPx: number): NavTier {
  if (widthPx <= NAV_BREAKPOINTS.mobileMax) return 'mobile'
  if (widthPx <= NAV_BREAKPOINTS.tabletMax) return 'tablet'
  if (widthPx <= NAV_BREAKPOINTS.smallDesktopMax) return 'small-desktop'
  if (widthPx <= NAV_BREAKPOINTS.desktopMax) return 'desktop'
  return 'xl'
}

export function isMobileTier(tier: NavTier): boolean {
  return tier === 'mobile'
}

export function isTabletTier(tier: NavTier): boolean {
  return tier === 'tablet'
}

export function isDesktopTier(tier: NavTier): boolean {
  return tier === 'small-desktop' || tier === 'desktop' || tier === 'xl'
}

export const SIDEBAR_COLLAPSED_KEY = 'cnect.employer.sidebar.collapsed'

export const SIDEBAR_WIDTH_PX = Object.freeze({
  expanded: 280,
  collapsed: 80,
})
